import { useEffect } from 'react'
import { useModelCtx } from '../model/z-index'
import { useZIndexModal } from '@rst/libs-ts'

export const ZIndexHandler = ({ id }) => {
	const { setZIndex } = useModelCtx()
	const zIndex = useZIndexModal(id)

	useEffect(() => {
		setZIndex(zIndex)
	}, [zIndex])

	return null
}
